import React, { useEffect, useRef, useState } from "react";
import "./home.css";
import { COUNTRIES } from "../../data/cc100";
import { useAuth } from "../../context/auth";
import { NavLink } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { base_URL } from "../../data/constant";

class IntervalTimer {
  callbackStartTime;
  remaining = 0;
  paused = false;
  timerId = null;
  _callback;
  _delay;

  constructor(callback, delay) {
    this._callback = callback;
    this._delay = delay;
  }

  pause() {
    if (!this.paused) {
      this.clear();
      this.remaining = new Date().getTime() - this.callbackStartTime;
      this.paused = true;
    }
  }

  resume() {
    if (this.paused) {
      if (this.remaining) {
        setTimeout(() => {
          this.run();
          this.paused = false;
          this.start();
        }, this.remaining);
      } else {
        this.paused = false;
        this.start();
      }
    }
  }

  clear() {
    clearInterval(this.timerId);
  }

  start() {
    this.clear();
    this.timerId = setInterval(() => {
      this.run();
    }, this._delay);
  }

  run() {
    this.callbackStartTime = new Date().getTime();
    this._callback();
  }
}

const UserTable = () => {
  return (
    <section className="home_tabs">
      <table style={{ tableLayout: "fixed" }}>
        <thead>
          <tr>
            <th style={{ width: "10vw" }}>Time</th>
            <th style={{ width: "10vw" }}>Position P</th>
            <th style={{ width: "10vw" }}>User</th>
            <th style={{ width: "10vw" }}>CC</th>
            <th style={{ width: "10vw" }}>PLP</th>
            <th style={{ width: "10vw" }}>Profit</th>
            <th style={{ width: "10vw" }}>KOTTO</th>
            <th style={{ width: "10vw" }}>Total P</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ALL</td>
            <td>ALL</td>
            <td>Open</td>
            <td>1.00</td>
            <td>0</td>
            <td>0.00</td>
            <td>0.00</td>
            <td>0.00</td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export const Home = () => {
  const { loggedIn, isPremiumMode, currentUser } = useAuth();

  const quantity_input = useRef();
  const quantity_sell_input = useRef();
  const [totalSharePrice, setTotalSharePrice] = useState(0);

  const [game_response, setGame_response] = useState({});
  const [unitValue, setUnitValue] = useState(1);

  const [trade_rate, setTrade_rate] = useState(null);
  const [eleminatedCountry, setEliminatedCountry] = useState(null);

  const calculate_total_amount = () => {
    if (buySellClick.buy) {
      setTotalSharePrice(quantity_input.current.value * unitValue);
    }
  };

  const play_query = useMutation(
    ["@play_query"],
    (config) =>
      axios.get(
        `${base_URL}/api/play/${currentUser._id}/${config.current_index}/${config.current_type}/${config.current_quantity}`
      ),
    {
      onSuccess: (data) => {
        console.log(data.data);
        setEliminatedCountry(
          data.data.letUserGameStatusUpdated.eleminated_countries
        );
      },
    }
  );

  const handleGameShareBuyAndSell = () => {
    let data_to_send = {
      current_index: null,
      current_type: null,
      current_quantity: null,
    };

    if (buySellClick.buy) {
      if (quantity_input.current.value >= 0) {
        data_to_send = {
          current_index: selectedCountry.id,
          current_type: "buy",
          current_quantity: quantity_input.current.value,
        };
        play_query.mutate(data_to_send);
      }
    }

    play_query.mutate(data_to_send);
  };

  const countries_query = useQuery(["@get_all_trade_countries"], () =>
    axios.get(`${base_URL}/api/get_all_trade_countries`)
  );

  // Selected country code from the CC Tile.
  const [selectedCountry, setSelectedCountry] = useState({
    code: "CC",
    name: "Trade",
    id: 0,
  });

  // timer ref for setInterval
  const timerRef = useRef(
    new IntervalTimer(() => {
      setGameTimer((prev) => {
        return prev - 1;
      });
    }, 1000)
  );

  const long_timerRef = useRef();
  const [longTimer, setLongTimer] = useState(60);

  // state to keep the track of the current time in the timer;
  const [gameTimer, setGameTimer] = useState(10);

  // state to check which button has been clicked? Buy or Sell button.
  const [buySellClick, setBuySellClick] = useState({
    buy: true,
    sell: false,
  });

  const [gamePausePlay, setGamePausePlay] = useState({
    play: false,
    pause: true,
  });

  const [isGameModeSelected, setGameModeSelected] = useState(false);

  const [buyItemHover, setBuyItemHover] = useState(false);

  const ref = useRef(null);

  // Use effect whenever timer value changes. It's like a callback whenever timer value changes.
  useEffect(() => {
    if (gameTimer < 0) {
      // The timer ends here
      resetTimer();
    }

    // If the code is not CC then only access the DOM element otherwise it will throw error because the DOM is not holding an element with the class name as it's being rendered conditionally.
    if (selectedCountry.code !== "CC") {
      if (document.getElementsByClassName("timer-title")[gameTimer]) {
        document.getElementsByClassName("timer-title")[
          gameTimer
        ].style.visibility = "hidden";
        document.getElementsByClassName("timer-title")[
          gameTimer
        ].style.opacity = "0";
      }
    }
  }, [gameTimer]);

  const resetTimer = () => {
    console.log("Reset timer");
    for (
      let index = 0;
      index < document.getElementsByClassName("timer-title").length;
      index++
    ) {
      const element = document
        .getElementsByClassName("timer-title")
        .item(index);
      element.style.visibility = "visible";
      element.style.opacity = "1";
    }
    setGameTimer(document.getElementsByClassName("timer-title").length);

    startTimer();
  };

  // Start the timer.
  const startTimer = () => {
    timerRef.current.start();
  };

  useEffect(() => {
    const onClickOutside = () => {
      setGameModeSelected(false);
    };
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return (
    <main className="wrapper_home">
      {loggedIn && <UserTable />}

      <section className="home_tabs">
        <table style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={{ width: "5vw" }}>CC</th>
              <th style={{ width: "7.5vw" }}>Trade</th>
              <th style={{ width: "7.5vw" }}>Price</th>
              <th style={{ width: "10vw" }}>Quantity</th>
              <th style={{ width: "10vw" }}>Value</th>
              <th style={{ width: "10vw" }}>Cost</th>
              <th style={{ width: "10vw" }}>Open</th>
              <th style={{ width: "10vw" }}>Closed</th>
              <th style={{ width: "10vw" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>ALL</td>
              <td>Open</td>
              <td>1.00</td>
              <td>0</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>0.00</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Only show this if the country is selected form the tile. */}
      {selectedCountry.code !== "CC" && (
        <section className="timer_section">
          <p>Tile Knockout Process: 10 secs &nbsp;&nbsp; RNG@random.org</p>
          <div className="timer_display">
            <div>0</div>
            <div>1</div>
            <div>2</div>
            <div>3</div>
            <div>4</div>
            <div>5</div>
            <div>6</div>
            <div>7</div>
            <div>8</div>
            <div className="dis-flex justify_content-space_between">
              <p className="mb-0">9</p> <p className="mb-0">●</p>{" "}
              <p className="mb-0 ">10</p>
            </div>
          </div>
          <div className="timer_display--box">
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
            <div className="timer-title" />
          </div>
        </section>
      )}

      <section className="home_section">
        <ul className="section_list">
          <li
            className="w-100"
            style={{
              color: isPremiumMode || buyItemHover ? "#00FFFF" : "inherit",
            }}
          >
            <p className="font-weight-normal d-flex-center">Premium Credits</p>
          </li>
          <li
            className="hover_item "
            onMouseOver={() => setBuyItemHover(true)}
            onMouseOut={() => setBuyItemHover(false)}
          >
            <button className="font-weight-bold">BUY</button>
            <div className="hover_menu buy_menu ">
              <label>Quantity</label>
              <input type={"number"} />
              <label>USD</label>
              <input type={"number"} />
              <span></span>
              <button className="hover_confirm-btn">Confirm</button>
            </div>
          </li>
          <li
            ref={ref}
            onClick={() => setGameModeSelected(!isGameModeSelected)}
            className={"hover-link"}
          >
            <NavLink
              to="/game-log"
              className={"font-weight-normal"}
              style={{
                color: isGameModeSelected ? "#00d2ff" : "white",
              }}
            >
              Game Log
            </NavLink>
          </li>
          <li
            className="w-100"
            style={{
              backgroundColor: "#2e2e2e",
            }}
          >
            <p className="font-size-12pt font-weight-normal">
              KO 100 Trading Platform
            </p>
          </li>
          <li>
            <p className="font-weight-normal">05:30 GMT</p>
          </li>
          <li
            style={{
              backgroundColor:
                selectedCountry.code !== "CC" ? "#76A5AF" : "inherit",
              color: "white",
            }}
          >
            <p>{selectedCountry.code}</p>
          </li>
          <li
            className={
              selectedCountry.code === "CD" ||
              selectedCountry.code === "US" ||
              selectedCountry.code === "VG"
                ? "fluid-font-size"
                : ""
            }
            style={{
              backgroundColor: "white",
              color: "black",
            }}
          >
            <p>{selectedCountry.name}</p>
          </li>
        </ul>

        <div className="section_part2">
          <div className="buy__sell__area">
            {selectedCountry.code !== "CC" && (
              <div className="dis-flex flex_direction-col align_item-end">
                <div className="dis-flex flex_gap-10 align_item-center">
                  <p className="mb-0">Unit Value</p>
                  <p className="unit__value__text mb-0">1.00</p>
                </div>
                {gamePausePlay.play && (
                  <button
                    className="same-box-width-height"
                    onClick={handleGameShareBuyAndSell}
                  >
                    Confirm
                  </button>
                )}
              </div>
            )}
            <div className="section_inputArea">
              <button
                onClick={() =>
                  setBuySellClick((prev) => ({ buy: true, sell: false }))
                }
              >
                Buy
              </button>
              <p
                className={`${
                  buySellClick.buy &&
                  selectedCountry.code !== "CC" &&
                  "black_and_white_text"
                }`}
              >
                0.00
              </p>
              <button
                onClick={() =>
                  setBuySellClick((prev) => ({ buy: false, sell: true }))
                }
              >
                Sell
              </button>
              <p
                className={`${
                  selectedCountry.code !== "CC" &&
                  buySellClick.sell &&
                  "black_and_white_text"
                }`}
              >
                0.00
              </p>
            </div>
            {selectedCountry.code !== "CC" && (
              <div className="quantity__total__table">
                <p>Quantity</p>
                <p>Total</p>

                {/* Condition to check which button has been clicked and show the tile according to it */}
                {buySellClick.buy && (
                  <>
                    <input
                      type="number"
                      ref={quantity_input}
                      onChange={calculate_total_amount}
                      className="unit__value__text"
                    />
                    <input
                      type="number"
                      className="unit__value__text unit__value__text--total"
                      disabled
                      value={totalSharePrice}
                    />
                    <input type="number" />
                    <input type="number" />
                  </>
                )}
                {/* Condition to check which button has been clicked and show the tile according to it */}
                {buySellClick.sell && (
                  <>
                    <input type="number" />
                    <input type="number" />
                    <input
                      type="number"
                      ref={quantity_sell_input}
                      className="unit__value__text"
                    />
                    <input
                      type="number"
                      className="unit__value__text unit__value__text--total"
                      value={totalSharePrice}
                      disabled
                    />
                  </>
                )}
              </div>
            )}
          </div>
          <div className="section_middle">
            <div className="middle_controls">
              <p className="section_middle_width_height">5.00</p>
              <button
                disabled={selectedCountry.code === "CC"}
                onClick={() => {
                  setGamePausePlay((prev) => ({ play: true, pause: false }));
                  timerRef.current.pause();
                }}
                className="control_pause section_middle_width_height"
              >
                Pause
              </button>
            </div>
            <div className="info-table">
              <div className="info-table_head">
                <p>OPEN</p>
                <p>Closed</p>
                <p>Total</p>
              </div>
              <div className="info-table_data">
                <p>0.00</p>
                <p>0.00</p>
                <p>0.00</p>
              </div>
            </div>
            <div className="middle_controls">
              <p className="section_middle_width_height">0.00</p>
              <button
                onClick={() => {
                  setGamePausePlay((prev) => ({ play: true, pause: true }));
                  if (timerRef.current.paused) {
                    timerRef.current.resume();
                  }
                  startTimer();
                }}
                className="control_play section_middle_width_height"
                disabled={!loggedIn || selectedCountry.code === "CC"}
              >
                Play
              </button>
            </div>
          </div>
          <div className="section_cc">
            <div className="cc_grid_section">
              {countries_query.isSuccess &&
                countries_query.data.data.status === "success" &&
                countries_query.data.data.response.map((item) => (
                  <button
                    onClick={() => {
                      setSelectedCountry((prev) => {
                        if (selectedCountry.code === item.code) {
                          return {
                            code: "CC",
                            name: "Trade",
                          };
                        }
                        return {
                          ...prev,
                          code: item.code,
                          name: item.name,
                          id: item.count,
                        };
                      });
                    }}
                    style={{
                      backgroundColor:
                        selectedCountry.code === item.code
                          ? "#76A5AF"
                          : "#343434",
                      opacity:
                        eleminatedCountry !== null &&
                        eleminatedCountry.find(
                          (e) => e.eleminated_country_index === item.count
                        )
                          ? 0.25
                          : 1,
                    }}
                    disabled={
                      eleminatedCountry !== null &&
                      eleminatedCountry.find(
                        (e) => e.eleminated_country_index === item.count
                      )
                    }
                  >
                    {item.code}
                  </button>
                ))}
              {/* {COUNTRIES.map((item) => (
                <button
                  onClick={() => {
                    setSelectedCountry((prev) => {
                      if (selectedCountry.code === item.code) {
                        return {
                          code: "CC", 
                          name: "Trade",
                        };
                      }
                      return {
                        ...prev,
                        code: item.code,
                        name: item.name,
                      };
                    });
                  }}
                  style={{
                    backgroundColor:
                      selectedCountry.code === item.code
                        ? "#76A5AF"
                        : "#343434",
                  }}
                >
                  {item.code}
                </button>
              ))} */}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
